module.exports = __webpack_public_path__ + "img/3_121.545217b1.png";